.pageSwitcher {
    position: fixed;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    display: flex;
    align-items: center;
    background: var(--button-bg);
    border: 1px solid var(--border-primary);
    border-radius: 0.5rem;
    padding: 0.2rem;
    gap: 0.15rem;
}

.switchButton {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.85rem;
    border: none;
    border-radius: 0.375rem;
    background: transparent;
    color: var(--text-secondary);
    font-size: 0.8125rem;
    font-weight: 500;
    font-family: var(--font-sans);
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.switchButton:hover:not(.switchButtonActive) {
    color: var(--text-primary);
    background: var(--button-hover);
}

.switchButtonActive {
    background: var(--bg-primary);
    color: var(--text-primary);
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.switchIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

@media (max-width: 480px) {
    .switchButton {
        padding: 0.35rem 0.6rem;
        font-size: 0.75rem;
    }
}
